import { FaFacebookF, FaInstagram, FaGoogle } from 'react-icons/fa';
import logo from "../components/assets/logo.png";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary mx-auto text-white px-6 md:px-16 py-10">
      {/* Top Section */}
      <div className="grid md:grid-cols-4 gap-8 max-w-7xl mx-auto border-b border-gray-700 pb-8">
        
        {/* Logo & Get in Touch - Modified section */}
        <div className="md:col-span-2 text-center md:text-left">
          <div className="flex justify-center md:justify-start">
            <img src={logo} alt="Boost Solar" className="h-14 mb-4" />
          </div>
          <div className="mt-4 text-gray-300">
            <p><span className="font-semibold">Phone:</span> +91 95372 79900 </p>
            <p><span className="font-semibold">Email:</span> <a href="mailto:info@boostenergy.in" className="hover:underline">kksolarsolutions@gmail.com</a></p>
            <p className="mt-2">
              <span className="font-semibold">Address:</span> <br />
              OPP MANAV CIRCLE NAGARPALIKA ROAD, 391/3,  <br />
              TP-2, Anjar, Gujarat 370110
            </p>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h2 className="text-xl font-bold mb-4">Quick Links</h2>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:underline">Home</Link></li>
            <li><Link to="/services" className="hover:underline">Services</Link></li>
            <li><Link to="/about" className="hover:underline">About Us</Link></li>
            <li><Link to="/blogs" className="hover:underline">Blog</Link></li>
            <li><Link to="/solar-calculator" className="hover:underline">Solar Calculator</Link></li>
            <li><Link to="/contact" className="hover:underline">Contact</Link></li>
          </ul>
        </div>

        {/* Legal & Sitemap */}
        <div>
          <h2 className="text-xl font-bold mb-4">Legal</h2>
          <ul className="space-y-2">
            <li><Link to="/privacy-policy" className="hover:underline">Privacy Policy</Link></li>
            <li><Link to="/sitemap" className="hover:underline">Sitemap</Link></li>
          </ul>
        </div>
      </div>
      {/* Bottom Section */}
      <div className="max-w-7xl mx-auto mt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
        
        {/* Social Icons */}
        <div className="flex gap-4 text-lg text-gray-300">
          <a href=" https://share.google/8YCWU0vGlgYJYrqF4" className="hover:text-white"><FaFacebookF /></a>
          <a href="https://www.instagram.com/k_k_solar?igsh=MXF6NzR4N3c3YXlkMw==" className="hover:text-white"><FaInstagram /></a>
          <a href="https://share.google/ymsDgNCjhU0Egb6WL" className="hover:text-white"><FaGoogle /></a>
        </div>

        {/* Copyright */}
        <p>© 2025 KK SOLAR SOLUTIONS</p>
      </div>
    </footer>
  );
};

export default Footer;